define('presentation/signup/viewModels/signupHeaderViewModel',[
        'i18next',
        'common/promises/promiseFactory',
        'presentation/signup/common/signupPageIndicatorWidget'
    ],
    function() {
        return function() {
            const self = this;

            const PromiseFactoryConstructor = require('common/promises/promiseFactory');
            const _promiseFactory = new PromiseFactoryConstructor();

            const _indicatorWidget = require('presentation/signup/common/signupPageIndicatorWidget');
            const _i18n = require('i18next');

            let _disposables = [];

            self.isStepMessageVisible = ko.observable(false);
            self.stepMessage = ko.observable('');

            self.headingText = ko.observable('');
            self.subtitleText = ko.observable('');

            self.showHeading = ko.pureComputed(() => self.headingText() !== '');
            self.showSubtitle = ko.pureComputed(() => self.subtitleText() !== '');

            self.detached = () => {
                _disposables.forEach(subscription => subscription.dispose());
                _disposables = [];
            };

            self.activate = (data)  => {
                const setSelfValue = (name) => {
                    const value = data && data[name];
                    if (value === undefined || value === null) {
                        return;
                    }
                    if (ko.isObservable(value)) {
                        self[name](value());
                        _disposables.push(value.subscribe(self[name]));
                    } else {
                        self[name](value);
                    }
                };
                setSelfValue('headingText');
                setSelfValue('subtitleText');

                return _initialize();
            };

            const _initialize = () => {
                const { isStepMessageVisible, step, totalSteps } = _indicatorWidget.getStepState();

                self.isStepMessageVisible(isStepMessageVisible);

                if (isStepMessageVisible) {
                    self.stepMessage(_i18n.t('signupHeader:stepMessage', {
                        step: step,
                        totalSteps: totalSteps
                    }));
                }

                _promiseFactory.wait();
            };
        };
    });

